import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhoneInputComponent } from './phone-input.component';
import { NgxMaskModule } from 'ngx-mask';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    PhoneInputComponent,
  ],
  imports: [
    CommonModule,
    NgxMaskModule,
    FormsModule,
  ],
  exports: [
    PhoneInputComponent,
  ]
})
export class PhoneInputModule { }
